import {
  abortableFetch,
  DetailContext,
  useEventCallback,
} from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';
import { useContext } from 'react';

export function useDeleteApiKeyDialog() {
  const { source } = useContext(DetailContext);

  const callApi = useEventCallback((id: string) => {
    return abortableFetch(
      `${EvidenceApiUrl.SYSTEM_USERS}/${id}/integration-key/delete`,
      {
        method: 'DELETE',
      }
    );
  });

  const showButton = !!source.data?.apiKeyHash;

  return { callApi, showButton };
}
